import { Row as AntdRow } from 'antd';
import PropTypes from 'prop-types';
import cn from 'classnames';
import s from './antdOverrides.module.less';

const Row = ({ block, gutter, children, className }) => (
  <AntdRow gutter={gutter} className={cn(block && s.rowBlock, className)}>
    {children}
  </AntdRow>
);

Row.defaultProps = {
  gutter: 0,
  block: false,
  children: null,
  className: null,
};

Row.propTypes = {
  gutter: PropTypes.number,
  block: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Row;
